import { SFTP, sftpDefaults, sftpSaveErrors, validateSftp } from './components/sftp';

/**
 * Self-contained integrations. To add one, create a component under ./components and add an entry:
 *   key       — matches the SystemText path (Admin/Integrations/<key>/Title) and the badge image name
 *   tags      — search tags shown on the integrations page
 *   Form      — controlled component: ({ values, onChange(patch), errors, user, visible }) — `values` is
 *               the whole draft integration settings object; `visible` is true while its form is open
 *               (every form is mounted, hidden, when the page opens)
 *   validate  — optional: async (values, user) => errors object (empty when valid); run on save
 *               while this integration's form is open
 *   defaults  — optional: field defaults applied when a saved value is missing/falsy
 *
 * Integrations still defined inline in index.jsx are migrated here as they are reworked.
 */
export const integrationRegistry = [
    {
        key: 'SFTP',
        tags: ['general'],
        Form: SFTP,
        validate: validateSftp,
        saveErrors: sftpSaveErrors,
        defaults: sftpDefaults,
    },
];

/** Builds the draft integration settings from the saved ones, filling in registry defaults. */
export const withDefaults = saved => {
    const draft = { ...saved };
    integrationRegistry.forEach(({ defaults = {} }) =>
        Object.entries(defaults).forEach(([field, value]) => {
            if (!draft[field]) draft[field] = value;
        })
    );
    return draft;
};
